import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

export const OpenWithFaireSignUpOuterContainer = styled(Column).attrs({
  justify: "center",
  align: "center",
})`
  height: 100%;
  width: 100%;
  padding: 0 16px;
`;

export const OpenWithFaireSignUpTagLine = styled(Typography)`
  &&& {
    letter-spacing: 1px;
  }
`;

export const OpenWithFaireSignUpTitle = styled(Typography)`
  &&& {
    max-width: 433px;
  }
`;

export const OpenWithFaireSignUpActionButton = styled(Button)`
  width: 100%;
  max-width: 264px;
`;

export const SquareMeterSuffix = (
  <Typography>
    m<sup>2</sup>
  </Typography>
);
